// Détermine comment proposer l'installation de la PWA selon l'environnement.
// Fonction pure : l'environnement est passé en paramètre pour être testable.

/**
 * @param {object} env
 * @param {boolean} env.standalone      déjà lancé depuis l'écran d'accueil
 * @param {boolean} env.hasPromptEvent  le navigateur a émis beforeinstallprompt (Chrome/Edge/Samsung)
 * @param {string}  env.userAgent
 * @returns {'none'|'prompt'|'ios-hint'}
 */
export function getInstallMode({ standalone, hasPromptEvent, userAgent = '' }) {
  if (standalone) return 'none';
  if (hasPromptEvent) return 'prompt';
  if (isIosSafari(userAgent)) return 'ios-hint';
  return 'none';
}

/**
 * La popup d'installation peut-elle être proposée à nouveau ?
 * @param {number|null|undefined} lastOfferedAt  horodatage (ms) du dernier affichage, absent si jamais proposée
 * @param {number} now                           horodatage (ms) courant
 * @param {number} intervalDays                  délai minimal entre deux propositions
 */
export function isInstallOfferDue(lastOfferedAt, now, intervalDays) {
  if (!Number.isFinite(lastOfferedAt)) return true;
  // Horloge revenue en arrière (date du téléphone modifiée) : on ne bloque pas indéfiniment
  if (lastOfferedAt > now) return true;
  return now - lastOfferedAt >= intervalDays * 24 * 60 * 60 * 1000;
}

/** iPhone/iPad sous Safari (les autres navigateurs iOS ne permettent pas l'installation) */
export function isIosSafari(userAgent) {
  const ua = String(userAgent);
  const ios = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && /Mobile/i.test(ua));
  const otherBrowser = /CriOS|FxiOS|EdgiOS|OPiOS|OPT\//i.test(ua);
  return ios && !otherBrowser && /Safari/i.test(ua);
}
